import React from 'react'
import { MiFooter } from '../../components/footer/MiFooter'
import { useContext } from 'react'
import { UsuarioContext } from '../../contexts/UsuarioContext'
import { ContentPreguntasFrecuentes } from '../../components/preguntasFrecuentes/ContentPreguntasFrecuentes'
import './PreguntasFrecuentes.css'
import { Helmet } from 'react-helmet'
import HeaderHome from '../../components/headerHome/HeaderHome'

export const PreguntasFrecuentes = () => {

    const [MenuLateral, setMenuLateral] = useContext(UsuarioContext)
    const closeMenu = () => {
        if (MenuLateral === true) {
            setMenuLateral(false)
        }
    }

    return (
        <div>
            <Helmet>
                <link rel="canonical" href="https://www.cuidatia.org/preguntas-frecuentes" />
            </Helmet>
            <div className='headerReservarServicio'>
                <HeaderHome />
            </div>
            <div className='faq-body'>
                <ContentPreguntasFrecuentes />
            </div>
            <div className='footerReservarServicio'>
                <MiFooter />
            </div>
        </div>
    )
}